<template>
    <div>
        <header-portrate />
        <div style="margin-bottom:70px;">
            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:100px !important;`">
                <v-col cols="12">
                    <h3>{{ lang.technician_ratings_dashboard }}</h3>
                </v-col>
            </v-row>
            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;`">
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="rows"
                        :items-per-page="-1"
                        class="elevation-1"
                        hide-default-footer
                        fixed-header
                        :loading="loading"
                    >
                        <template v-slot:item="row">
                            <tr>
                                <td style="text-align:center;">{{ row.item.employee_name }}</td>
                                <td style="text-align:center;color:#2e7d32;font-weight:bold;">{{ row.item.excellent }}</td>
                                <td style="text-align:center;color:#1976d2;font-weight:bold;">{{ row.item.good }}</td>
                                <td style="text-align:center;color:#c62828;font-weight:bold;">{{ row.item.bad }}</td>
                                <td style="text-align:center;">{{ row.item.total_rated }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
        <Footer />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'
export default{
    components: { HeaderPortrate, Footer },
    data() {
        return {
            rows: [],
            loading: false,
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki) == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki) == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        headers(){
            return [
                { text: this.lang.employee_name, value: 'employee_name', sortable: false },
                { text: this.lang.excellent, value: 'excellent', sortable: false },
                { text: this.lang.good, value: 'good', sortable: false },
                { text: this.lang.bad, value: 'bad', sortable: false },
                { text: this.lang.total, value: 'total_rated', sortable: false },
            ];
        },
    },
    methods: {
        getRatings(){
            this.loading = true;
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'getTechnicianRatingsDashboard');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((res) => {
                this.loading = false;
                if(res.data.error && res.data.error.number === 200){
                    this.rows = res.data.results;
                }
            }).catch(() => { this.loading = false; });
        },
    },
    created(){
        this.getRatings();
    },
}
</script>
